export function handleModal(modals, firstModal, secondModal, firstValue, secondValue, thirdValue, thirdModal) {
    modals[firstModal] = firstValue;
    modals[secondModal] = secondValue;
    if (thirdModal !== undefined) {
        modals[thirdModal] = thirdValue;
    }
}
export function validateFields(mandatoryFields, object, errors, errorMessage) {
    errors.value = [];
    var hasError = false;
    var value = null;
    mandatoryFields.forEach(function (field, index) {
        if (typeof field != 'string') {
            value = object[field[0]][field[1]];
        }
        else {
            value = object[field];
        }
        if (!value) {
            hasError = true;
            errors.value.push(errorMessage);
        }
        else {
            errors.value.push("");
        }
    });
    if (hasError) {
        return false;
    }
    return true;
}
export function isValidDate(dateString) {
    // Controlla se la data segue il formato GG-MM-AAAA
    var regex = /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/;
    if (!regex.test(dateString)) {
        return false;
    }
    var _a = dateString.split('-').map(Number), day = _a[0], month = _a[1], year = _a[2];
    // Controlla se i numeri del giorno, mese e anno sono validi
    if (isNaN(day) || isNaN(month) || isNaN(year)) {
        return false;
    }
    // Verifica se il mese è valido (da 1 a 12)
    if (month < 1 || month > 12) {
        return false;
    }
    // Verifica se il giorno è valido per il mese specificato
    var date = new Date(year, month - 1, day);
    if (date.getDate() !== day) {
        return false;
    }
    // La data è valida
    return true;
}
export function capitaliseFirstLetter(subject) {
    return subject.split(' ').map(function (word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }).join(' ');
}
export function compareDates(date1, date2) {
    if (date1 > date2) {
        return false;
    }
    return true;
}
